"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=require("@mui/material"),o=require("../../emotion-react.browser.esm-981c4409.js"),i=require("./dialog.constants.js");require("react");require("../../extends-7fef164d.js");require("../../hoist-non-react-statics.cjs-081bcdb8.js");const s=r.styled("span")`
  width: 100%;
`,c=r.styled("div")`
  ${({width:e})=>e&&o.css`
      width: ${e}px;
    `}
`,n=r.styled(r.DialogTitle,{shouldForwardProp:e=>e!=="colorVariant"&&e!=="draggable"})(({theme:e,draggable:a,colorVariant:l})=>{let t="";switch(a&&(t+=`
      &.${i.HANDLE_CLASS} {
        cursor: grab;
      }
    `),l){case"grey":{t+=`
        &&& {
          background-color: ${e.palette.grey[300]};
          color: ${e.palette.grey[800]};
        }
      `;break}case"warning":{t+=`
        &&& {
          background-color: ${e.palette.secondary[50]};
          color: ${e.palette.grey[900]};
        }
      `;break}case"error":{t+=`
        &&& {
          background-color: ${e.palette.error[50]};
          color: ${e.palette.grey[800]};
        }
      `;break}}return t}),d=r.styled(r.Typography,{shouldForwardProp:e=>e!=="colorVariant"})`
  ${({colorVariant:e})=>{switch(e){case"grey":return o.css`
          &&& {
            text-decoration: line-through;
          }
        `;default:return""}}}
`,g=r.styled(r.Dialog,{shouldForwardProp:e=>e!=="initialPosition"})`
  .${r.dialogClasses.container} {
    justify-content: ${({initialPosition:e})=>e?"flex-start":"center"};
    align-items: ${({initialPosition:e})=>e?"flex-start":"center"};
  }
`;exports.HeaderTextWrapper=s;exports.StyledDialogTitle=n;exports.StyledMuiDialog=g;exports.StyledSubtitle=d;exports.Wrapper=c;
